// Configuration for different environments
const config = {
  development: {
    API_BASE_URL: 'http://127.0.0.1:5001'
  },
  production: {
    API_BASE_URL: 'https://labreportssimplified.onrender.com' // Removed the fallback
  }
};

// Get current environment
const environment = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export default config[environment];